export const LOAD_AS_FILED_JOB_TYPE = 'manual-refresh-gtw-federal-info';
export const PARSE_TTI_FEDERAL_XML = 'parse-tti-federal-xml';
